window.addEventListener('DOMContentLoaded', () => {
  const fade = (entries) => {
    entries.forEach((entry) => {
      const fadeTargetID = entry.target.dataset.fixedFadeIntersectionTarget;
      const fadeTarget = document.getElementById(fadeTargetID);
      if(!fadeTarget) return;
      fadeTarget.style.transition = "opacity 0.2s";
      fadeTarget.style.opacity = 1 - entry.intersectionRatio;
      fadeTarget.style.pointerEvents = entry.intersectionRatio === 0 ? "auto" : "none";
    });
  };
  const observer = new IntersectionObserver(fade, {
    root: null,
    rootMargin: "0px",
    threshold: [0, 1],
  });
  document.querySelectorAll('[data-fixed-fade-intersection-target]').forEach((element) => {
    observer.observe(element);
  });
});
